export const ALGORITHM_INITIALIZE = 'ALGORITHM.INITIALIZE'
export const ALGORITHM_CHANGE_GLOBALS = 'ALGORITHM.CHANGE_GLOBALS'
export const ALGORITHM_START = 'ALGORITHM.START'
export const ALGORITHM_STEP = 'ALGORITHM.STEP'
export const ALGORITHM_RUN = 'ALGORITHM.RUN'

export const INSPECTOR_HIGHLIGHT = 'INSPECTOR.HIGHLIGHT'
export const INSPECTOR_CLEAR = 'INSPECTOR.CLEAR'



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js